var _path, _path2, _ellipse, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeMutedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.33318C0 1.78089 0.447715 1.33318 1 1.33318H3.20008V6.66664H0.999999C0.447714 6.66664 0 6.21892 0 5.66664V2.33318Z",
    fill: "#AE1942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20032 6.66664V1.33317L4.80036 0.666488L6.4004 -0.00019455V8L4.80036 7.33332L3.20032 6.66664Z",
    fill: "#AE1942"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.39997,
    cy: 3.9999,
    rx: 1.60004,
    ry: 1.33337,
    fill: "#AE1942"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.13584,
    height: 9.08668,
    transform: "matrix(0.622543 0.782585 -0.622543 0.782585 14.6569 0)",
    fill: "#AE1942"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.13584,
    height: 9.08668,
    transform: "matrix(-0.622543 0.782585 -0.622543 -0.782585 15.364 7.11111)",
    fill: "#AE1942"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMutedIcon);
export default __webpack_public_path__ + "static/media/volume-muted-icon.199fcfa3438b21090ecf4ba6ea8d32d2.svg";
export { ForwardRef as ReactComponent };